<template>
  <div class="check-in">
    <header>
      <BrandHeader />
    </header>

    <CheckinMainFlow @submit-form="doTheSubmitCheckin" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

import BrandHeader from '@/components/layout/BrandHeader';
import CheckinMainFlow from './partials/CheckinMainFlow.vue';
import dataLayerPushAdmission from '@/utils/mixins/dataLayerPushAdmission';
import checkinMixins from '@/utils/mixins/checkin.mixins';
import { dataLayersMixin, originUserCkeckIn } from '@/utils/mixins';
import {
  LOCAL_STORAGE_ALTERNATIVE_MESSAGE,
  LOCAL_STORAGE_URL_TOKEN,
  LOCAL_STORAGE_BRAND_ID,
  LOCAL_STORAGE_UNIT_ID,
} from '@/utils/constants/checkin.constants';

export default {
  name: 'CheckIn',
  mixins: [dataLayerPushAdmission, checkinMixins, dataLayersMixin, originUserCkeckIn],

  components: {
    BrandHeader,
    CheckinMainFlow,
  },

  data: () => ({
    userSelected: '',
  }),

  created() {
    this.setAppConfigVariables();
    this.inputCPFAutofiller();
    this.checkUserCheckinOrigin();

    this.dataLayerReset();

    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Identificação',
    });
  },
  computed: {
    ...mapState({
      unitsList: ({ brandUnit }) => brandUnit.data.unitsList,
      selectedUnit: ({ brandUnit }) => brandUnit.data.selectedUnit,
    }),
    ...mapGetters({
      enumUnitSelected: 'enumUnitSelected',
      getBrandUnitIdVariables: 'getBrandUnitIdVariables',
      selectedBrand: 'selectedBrand',
    }),
    brandUnitId() {
      const unitId = parseInt(this.$route.params.unitId);
      const brandId = parseInt(this.$route.params.brandId);

      return { brandId, unitId };
    },
  },
  methods: {
    ...mapActions(['getUnitConfigs', 'dataProviderGetUnits', 'resetStates', 'setTeamName']),

    ...mapMutations({
      setUnit: 'SET_UNIT',
      setUrlAdmissionToken: 'SET_VALIDATION_URL_TOKEN',
      setCurrentUnitVariables: 'SET_CURRENT_UNIT_NAME_ID',
      setCurrentBrandVariables: 'SET_CURRENT_BRAND_NAME_ID',
      setAlternativeMessageData: 'global/SET_ALTERNATIVE_MESSAGE_DATA',
      clearAlternativeMessageData: 'global/CLEAR_ALTERNATIVE_MESSAGE_DATA',
    }),

    checkUserCheckinOrigin() {
      if (this.$route.query) {
        // eslint-disable-next-line
        const { utm_medium, utm_source, t } = this.$route?.query;
        this.checkinOriginUser({ utm_medium, utm_source, t });
      }
    },
    /**
     * @method setAppConfigVariables
     * @description Calls set up methods
     */
    async setAppConfigVariables() {
      const { brandId, unitId } = this.brandUnitId;
      this.resetStates();
      this.storageRouteData();
      this.setDataBrandUnitId(brandId, unitId);

      if (this.$route.query) {
        this.setDataFromUrlQuery();
      }

      this.getUnitConfigs(unitId);
      this.setTeamName();
      this.fetchDataProviderUnitInfo();
    },
    /**
     * @method storageRouteData
     * @description Sets urlToken in localStorage (URL param and query)
     *
     */
    storageRouteData() {
      const urlToken = this.validateUrlToken();

      urlToken && localStorage.setItem(LOCAL_STORAGE_URL_TOKEN, urlToken);
    },
    validateUrlToken() {
      let urlToken = this.$route.params.admissionID;

      if (urlToken && urlToken.length > 8) {
        urlToken = urlToken.slice(0, 8);
      }

      this.setUrlAdmissionToken(urlToken);
      return urlToken;
    },
    doTheSubmitCheckin(...args) {
      this.submitCpfViewAnalytics(!!this.urlToken, 'login');
      this.startCheckin(...args);
    },
    /**
     * @method setDataBrandUnitId
     * @description Sets values (brandId/unitId) in localStorage (URL params based)
     * if exists on Location
     */
    setDataBrandUnitId() {
      const { brandId, unitId } = this.brandUnitId;

      if (brandId && unitId) {
        this.setCurrentUnitVariables({ unitId });
        this.setCurrentBrandVariables({ brandId });

        localStorage.setItem(LOCAL_STORAGE_BRAND_ID, brandId);
        localStorage.setItem(LOCAL_STORAGE_UNIT_ID, unitId);
      }
    },
    /**
     * @method setDataFromUrlQuery
     * @description Verify utm_medium on url query & set data on localStore for the flux.
     */
    setDataFromUrlQuery() {
      const { utm_medium: utmMedium, utm_source: utmSource } = this.$route.query;

      if (utmMedium && utmSource) {
        const alternativeMessageData = { alternativeEndFlowMessage: true };

        this.setAlternativeMessageData(alternativeMessageData);
        localStorage.setItem(
          LOCAL_STORAGE_ALTERNATIVE_MESSAGE,
          JSON.stringify(alternativeMessageData),
        );
      }
    },
    /**
     * @method setTeamName
     * @description Store teamName from router params
     */
    setTeamName() {
      if (this.$route.params.teamName) {
        this.setTeamName(this.$route.params.teamName);
      }
    },
    /**
     * @method fetchDataProviderUnitInfo
     * @description Store unit data from Data Provider API
     */
    async fetchDataProviderUnitInfo() {
      const { brandId, unitId } = this.brandUnitId;

      await this.dataProviderGetUnits({ idMarca: brandId });
      const selectedUnit = this.unitsList?.find((unit) => unit.idUnidade === parseInt(unitId));

      this.setUnit(selectedUnit);
    },
    removeAlternativeMessageData() {
      if (localStorage.alternativeMessageData) {
        localStorage.removeItem(LOCAL_STORAGE_ALTERNATIVE_MESSAGE);
        this.clearAlternativeMessageData();
      }
    },
    submitCpfViewAnalytics() {
      this.mostCommonPagesAnalytics({
        eventType: 'funnel_step',
        currentStep: 'Validação de identidade',
      });
    },
  },
};
</script>

<style lang="scss">
.check-in {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 8px 8px;
}
</style>
